/**
 * @author jiangtao
 * @Date 2020/02/08
 * @description 定义一些全局的windows处理方法， 简化调用
 * @param Vue
 * @param opts
 * @example this.$log(..) like console.log()
 * @return {*}
 */
const plugin = {
  install (Vue, opts) {
    opts = Object.assign({
      target: '_blank',
      features: 'toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes'
    }, opts)
    Object.defineProperty(Vue.prototype, '$open', {
      value (url, target = opts.target, features = opts.features) {
        if (url) {
          return window.open(url, target, features)
        } else {
          console.warn('[this.$open plugin] url is empty')
        }
      }
    })
  }
}

export default plugin
